export default __webpack_public_path__ + "static/Zug-c3cf37450f03fd07e8f249e45c0ba877.jpg";